'use client'

import { Box, Button, HStack, Text, VStack, Image } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'

const logoSvg = "http://localhost:3845/assets/b5077b7164f1b2bf2f86c4e5520d058f4e2df32e.svg"

export function TraderBottomNav() {
  const t = useTranslations()
  
  const handleOpenInApp = () => {
    const deepLink = 'wildmeta://'
    const fallbackUrl = '/app-download'
    
    // Try to open the deep link
    window.location.href = deepLink
    
    // Set up fallback redirect after a short delay
    const timeoutId = setTimeout(() => {
      window.location.href = fallbackUrl
    }, 2000)
    
    // Clear timeout if user returns to the page (deep link worked)
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        clearTimeout(timeoutId)
        document.removeEventListener('visibilitychange', handleVisibilityChange)
      }
    }
    
    document.addEventListener('visibilitychange', handleVisibilityChange)
  }

  return (
    <VStack
      gap={0}
      w="full"
      position="fixed"
      bottom={5}
      left={0}
      right={0}
      bg="transparent"
      zIndex={1000}
      justify="center"
      align="center"
    >
      {/* Top section with Open in App button */}
      <Button
        bg="white"
        color="black"
        borderRadius={25}
        h={12}
        px={4}
        py={2}
        fontWeight="semibold"
        fontSize="md"
        _hover={{
          bg: "gray.100"
        }}
        onClick={handleOpenInApp}
      >
        <HStack gap={2} align="center">
          <Box w={8} h={8}>
            <Image
              src="/images/logo.png"
              alt="Wildmeta Logo"
              objectFit="contain"
            />
          </Box>
          <Text
            fontFamily="'Noto Sans', sans-serif"
            fontWeight="semibold"
            fontSize="md"
            color="black"
            whiteSpace="nowrap"
          >
            {t('trader.openInApp')}
          </Text>
        </HStack>
      </Button>
    </VStack>
  )
}